/**
 * @generated SignedSource<<aa12debafd63c0051858f714304d8865>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type vehicletype = "C18" | "C36" | "C38" | "C93" | "DOCK_G17" | "DOCK_G27" | "DOCK_G47" | "E1" | "R1" | "R3" | "R47" | "R47_ISP" | "R47_XAVIER" | "R71" | "SIMULATOR" | "UNKNOWN" | "W17" | "%future added value";
export type ReleaseMaxFilterRefetchQuery$variables = {
  count?: number | null;
  cursor?: string | null;
  deviceTypes?: ReadonlyArray<vehicletype> | null;
  maxVersion?: string | null;
};
export type ReleaseMaxFilterRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ReleaseMaxFilter_query">;
};
export type ReleaseMaxFilterRefetchQuery = {
  response: ReleaseMaxFilterRefetchQuery$data;
  variables: ReleaseMaxFilterRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deviceTypes"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "maxVersion"
  }
],
v1 = {
  "kind": "Variable",
  "name": "deviceTypes",
  "variableName": "deviceTypes"
},
v2 = {
  "kind": "Variable",
  "name": "maxVersion",
  "variableName": "maxVersion"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "versioned",
    "value": true
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReleaseMaxFilterRefetchQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ReleaseMaxFilter_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReleaseMaxFilterRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ReleaseConnection",
        "kind": "LinkedField",
        "name": "releases",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ReleaseEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Release",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "uuid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "versionString",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "releaseKey",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "filters": [
          "versioned",
          "maxVersion",
          "deviceTypes"
        ],
        "handle": "connection",
        "key": "ReleaseMaxFilter_releases",
        "kind": "LinkedHandle",
        "name": "releases"
      }
    ]
  },
  "params": {
    "cacheID": "d068c5170b64130b604ab78120696bd0",
    "id": null,
    "metadata": {},
    "name": "ReleaseMaxFilterRefetchQuery",
    "operationKind": "query",
    "text": "query ReleaseMaxFilterRefetchQuery(\n  $count: Int = 10\n  $cursor: String\n  $deviceTypes: [vehicletype!]\n  $maxVersion: String\n) {\n  ...ReleaseMaxFilter_query_4DoJFc\n}\n\nfragment ReleaseMaxFilter_query_4DoJFc on Query {\n  releases(after: $cursor, first: $count, versioned: true, maxVersion: $maxVersion, deviceTypes: $deviceTypes) {\n    totalCount\n    edges {\n      node {\n        uuid\n        versionString\n        releaseKey\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "543ea09e48364c1d3714bf1151d88726";

export default node;
